import React, { useState } from "react";
import ArticleInfo from "@/components/ArticleInfo";
import SectionHeader from "@/components/SectionHeader";
import { fetchArticles } from "@/components/ArticleComponent/api";
import { getResourceListingURL } from "@/helpers";
import { FILTER_MAPPING } from "@/helpers/constants";
import styles from "./ArticleComponent.module.scss";

const ArticleComponent = (props) => {
  const { userAgent, pillarSlug, categorySlug, clusterSlug, data, registerRef, desktopItems, assetPosition } = props;
  const { articles: initialArticles, Tags, Heading, ShortDescription } = data;
  const tabs = Tags?.data;

  const [activeTab, setActiveTab] = useState<string>(tabs?.[0]?.attributes?.Slug);
  const [articles, setArticles] = useState(initialArticles);

  const handleTabChange: (tagName: string, tagSlug: string) => void = async (tagName, tagSlug) => {
    try {
      const response: any = await fetchArticles({ pillarSlug, clusterSlug, categorySlug, tagName });

      if (response?.length) {
        setArticles(response);
      } else {
        setArticles([]);
      }
    } catch (err) {
      setArticles([]);
      console.error(err);
    }

    setActiveTab(tagSlug);
  };

  return (
    <>
      <section
        data-ref_id={data?.refId}
        ref={(el) => {
          if (data?.ShowHeadingInIndex && registerRef && data?.refId) registerRef(data?.refId, el);
        }}
        className={`${styles.root} scrollMargin spacingBetweenSections`}
      >
        <div className={"container"}>
          <SectionHeader userAgent={userAgent} title={Heading} subTitle={ShortDescription} />
          {!!tabs?.length && (
            <div className={styles.tabsWrapper}>
              {tabs.map(({ id, attributes }) => {
                const isActive = activeTab === attributes?.Slug;

                return (
                  <button
                    type={"button"}
                    onClick={() => handleTabChange(attributes?.TagName, attributes?.Slug)}
                    key={id}
                    className={`${styles.tab} ${isActive ? styles.active : ""}`}
                  >
                    {attributes?.TagName}
                  </button>
                );
              })}
            </div>
          )}

          {/*TODO: Verify ctaURL, page logic is different*/}
          <ArticleInfo
            articles={articles}
            userAgent={userAgent}
            ctaURL={getResourceListingURL(
              {
                [FILTER_MAPPING.tag]: [activeTab],
                ...(clusterSlug
                  ? { [FILTER_MAPPING.cluster]: [clusterSlug] }
                  : { [FILTER_MAPPING.pillar]: [pillarSlug] }),
              },
              "articles"
            )}
            desktopItems={desktopItems}
            assetPosition={assetPosition}
          />
        </div>
      </section>
    </>
  );
};

export default ArticleComponent;
